import React from 'react'
import {Collapse as ANTCollapse} from 'antd';

import EmptyBanner from '../../../components/EmptyBanner'
import InfoTooltip from "../../../components/InfoTooltip";
import ProjectStep from "../components/ProjectStep";
import Project from "../../../models/Project";
import {Collapse} from "reactstrap";
import {generatePath, Link, Navigate} from "react-router-dom";
import Scrollbars from "react-custom-scrollbars"
import Service from "../../../models/Service";

const RolesSVG = ({fill = '#8B3EF0', height = 20, icon}) => {
    let svgicon;

    switch (icon) {
        case "star":
            svgicon = <path fill={fill}
                            d="M20.4,7.2l-5.7-0.8l-2.6-5.2c-0.4-0.9-1.8-0.9-2.2,0L7.3,6.4L1.6,7.2c-1,0.2-1.4,1.4-0.7,2.1l4.1,4l-1,5.7,c-0.2,1,0.9,1.8,1.8,1.3l5.1-2.7l5.1,2.7c0.9,0.5,2-0.3,1.8-1.3l-1-5.7l4.1-4C21.8,8.6,21.4,7.4,20.4,7.2z M15.6,12.9l1.1,6.3,l-5.7-3l-5.7,3l1.1-6.3L1.8,8.5l6.4-0.9L11,1.8l2.8,5.8l6.4,0.9L15.6,12.9z"/>;
            break;
        case "browser":
            svgicon = <path fill={fill}
                            d="M18.1,0.8H1.9C0.8,0.8,0,1.6,0,2.6v13.8c0,1.1,0.8,1.9,1.9,1.9h16.2c1,0,1.9-0.8,1.9-1.9V2.6C20,1.6,19.1,0.8,18.1,0.8z M1.2,2.6C1.2,2.3,1.5,2,1.9,2h1.9v2.5H1.2V2.6z M18.8,16.4c0,0.4-0.3,0.6-0.6,0.6H1.9c-0.4,0-0.6-0.3-0.6-0.6V5.8h17.5V16.4z M18.8,4.5H5V2h13.1c0.3,0,0.6,0.3,0.6,0.6V4.5z"/>;
            break;
        case "brush":
            svgicon = <path fill={fill}
                            d="M19.1,6.2c2.3-2.5-0.2-5.7-2.8-5.7c-0.9,0-1.8,0.4-2.5,1.4l-6.5,9.7c-1.8,0.1-3.4,0.8-4.3,3.2c-0.1,0.3-0.4,0.4-0.6,0.4,c-0.5,0-2-1.2-2.4-1.5c0,3.6,1.6,6.8,5.6,6.8c5.5,0,5.7-4.6,5.5-5.7L19.1,6.2z M9,18.1c-0.7,0.8-1.8,1.2-3.4,1.2c-2.5,0-3.6-1.4-4-3,c0.3,0.2,0.5,0.2,0.8,0.2c0.8,0,1.5-0.5,1.8-1.3c0.3-0.7,0.7-2.2,3.5-2.4l2.2,2C10,15.9,9.8,17.2,9,18.1z M10.5,13.7l-2-1.8l6.3-9.3,c0.4-0.6,0.9-0.9,1.5-0.9c0.9,0,1.9,0.7,2.2,1.5c0.3,0.7,0.2,1.4-0.4,2L10.5,13.7z"/>;
            break;
        case "strategy":
            svgicon = <path fill={fill}
                            d="M25.2,9.9H13.6V6.8h3.1c0.7,0,1.2-0.5,1.2-1.2V1.8c0-0.7-0.6-1.2-1.2-1.2H9.2C8.5,0.5,8,1.1,8,1.8v3.8,c0,0.7,0.5,1.2,1.2,1.2h3.1v3.1H0.8c-0.2,0-0.3,0.2-0.3,0.3v0.6c0,0.2,0.1,0.3,0.3,0.3h4.7v3.1H3c-0.7,0-1.2,0.6-1.2,1.2v3.8,c0,0.7,0.5,1.2,1.2,1.2h6.2c0.7,0,1.2-0.5,1.2-1.2v-3.8c0-0.7-0.6-1.2-1.2-1.2H6.8v-3.1h12.5v3.1h-2.5c-0.7,0-1.2,0.6-1.2,1.2v3.8,c0,0.7,0.5,1.2,1.2,1.2H23c0.7,0,1.2-0.5,1.2-1.2v-3.8c0-0.7-0.6-1.2-1.2-1.2h-2.5v-3.1h4.7c0.2,0,0.3-0.1,0.3-0.3v-0.6,C25.5,10,25.3,9.9,25.2,9.9z M9.2,15.5v3.8H3v-3.8H9.2z M9.2,5.5V1.8h7.5v3.8H9.2z M23,15.5v3.8h-6.2v-3.8H23z"/>;
            break;
        case "database":
            svgicon = <path fill={fill}
                            d="M14.7,9.5c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9C15.1,8.6,14.7,9,14.7,9.5z M13.1,10.4,c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9C12.2,10,12.6,10.4,13.1,10.4z M20,5.4V2.3,c0-1-0.9-1.9-1.9-1.9H1.9C0.8,0.4,0,1.3,0,2.3v3.1c0,0.5,0.2,0.9,0.5,1.2C0.2,7,0,7.5,0,7.9v3.1c0,0.5,0.2,0.9,0.5,1.2,C0.2,12.7,0,13.1,0,13.6v3.1c0,1.1,0.8,1.9,1.9,1.9h16.2c1,0,1.9-0.8,1.9-1.9v-3.1c0-0.5-0.2-0.9-0.5-1.2c0.3-0.3,0.5-0.7,0.5-1.2V7.9c0-0.5-0.2-0.9-0.5-1.2C19.8,6.4,20,5.9,20,5.4z M1.2,5.4V2.3c0-0.3,0.3-0.6,0.6-0.6h16.2c0.3,0,0.6,0.3,0.6,0.6v3.1,c0,0.4-0.3,0.6-0.6,0.6H1.9C1.5,6.1,1.2,5.8,1.2,5.4z M18.1,7.3c0.3,0,0.6,0.3,0.6,0.6v3.1c0,0.4-0.3,0.6-0.6,0.6H1.9,c-0.4,0-0.6-0.3-0.6-0.6V7.9c0-0.3,0.3-0.6,0.6-0.6H18.1z M18.8,13.6v3.1c0,0.4-0.3,0.6-0.6,0.6H1.9c-0.4,0-0.6-0.3-0.6-0.6v-3.1,c0-0.3,0.3-0.6,0.6-0.6h16.2C18.4,12.9,18.8,13.2,18.8,13.6z M15.6,4.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9,c-0.5,0-0.9,0.4-0.9,0.9C14.7,4.4,15.1,4.8,15.6,4.8z M13.1,4.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9,c-0.5,0-0.9,0.4-0.9,0.9C12.2,4.4,12.6,4.8,13.1,4.8z M15.6,14.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9,c0.5,0,0.9-0.4,0.9-0.9C16.6,14.6,16.1,14.2,15.6,14.2z M13.1,14.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9,c0.5,0,0.9-0.4,0.9-0.9C14.1,14.6,13.6,14.2,13.1,14.2z"/>;
            break;
        case "horn":
            svgicon = <path fill={fill}
                            d="M22.9,0.8h-0.6c-0.2,0-0.3,0.2-0.3,0.3v0.8L2,6.5V6.1c0-0.2-0.2-0.3-0.3-0.3H1.1c-0.2,0-0.3,0.2-0.3,0.3v6.9,c0,0.2,0.1,0.3,0.3,0.3h0.6c0.2,0,0.3-0.1,0.3-0.3v-0.4l5.1,1.2C7,14,7,14.2,7,14.5c0,2.1,1.6,3.8,3.8,3.8c1.8,0,3.2-1.2,3.6-2.9,l7.7,1.8v0.7c0,0.2,0.1,0.3,0.3,0.3h0.6c0.2,0,0.3-0.1,0.3-0.3V1.1C23.2,0.9,23.1,0.8,22.9,0.8z M10.8,17c-1.4,0-2.5-1.1-2.5-2.5,c0-0.2,0-0.4,0-0.5l4.8,1.1C12.9,16.2,11.9,17,10.8,17z M2,11.2V7.8l20-4.7v12.8L2,11.2z"/>;
            break;
        default:
            break;
    }
    return (
        <svg version="1.1" height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 21">
            {svgicon}
        </svg>
    )
}

const BYORoles = (props) => {
    const [activeKey, setActiveKey] = React.useState();

    let categories = TB.map([...laravel.discipline_categories], (category = {}) => {
        return {
            ...category,
            // TODO Change with updated discipline filters for client/talent
            disciplines: category.disciplines,//TB.filter(category.disciplines, ['is_contractable', true])
        }
    })
    const BYORoles = categories.sort((a, b) => {
        return a.display_index - b.display_index;
    });


    return (
        <React.Fragment>
            <div className="search-info text-center">
                <h1>Wripple Roles</h1>
            </div>
            <ANTCollapse
                activeKey={activeKey}
                accordion
                collapsible="header"
                className="border-primary border rounded-[20px] overflow-hidden"
                onChange={key => setActiveKey(key)}
            >
                {BYORoles.map(item => {
                    const panelHeader = (
                        <div className=" w-full flex justify-between">
                            <div className="flex items-center w-full cursor-default py-4 px-6"
                                 onClick={event => event.stopPropagation()}>
                                {item.icon_path ? <img src={item.icon_path} alt=""/> : (<RolesSVG icon="star"/>)}

                                <span className="ml-4">
                                    {item.name}
                                </span>
                            </div>

                            <button className="flex-1 px-6" type="button">
                                <i className={TB.mapClass('fas text-xl duration-200 transition', {
                                    'fa-minus-circle': activeKey === String(item.id),
                                    'fa-plus-circle rotate-90': activeKey !== String(item.id),
                                })}/>
                            </button>
                        </div>
                    );
                    return (
                        (<ANTCollapse.Panel showArrow={false} header={panelHeader} key={item.id}
                                            className="odd:bg-light-gray">
                            <ul className="list-disc pl-14">
                                {item.disciplines.map(discipline => {
                                    const key = `cat-${item.id}-role-${discipline.id}`;
                                    return (
                                        (<li key={key} className="my-1">
                                            <span id={key} className="relative">
                                                {discipline.name}
                                            </span>
                                            {!!discipline.description && ( // dont show tooltip if no discipline description
                                                (<InfoTooltip placement="right" target={key}>
                                                    <div className="p-3 text-left">
                                                        {discipline.description}
                                                    </div>
                                                </InfoTooltip>)
                                            )}
                                        </li>)
                                    );
                                })}
                            </ul>
                        </ANTCollapse.Panel>)
                    );
                })}
            </ANTCollapse>
            {!BYORoles.length && (
                <EmptyBanner message="No Roles Available"/>
            )}

        </React.Fragment>);
}


const byo_steps_descriptions = [
    {
        name: 'Project Brief',
        description: 'Tell us about your project including start date, description, duration and location.',
        iconColor: '#8A3FF0'
    },
    {
        name: 'Define Open Positions and Roles Needed',
        description: 'Define open project positions.  Set desired roles and skills and create your perfect unicorn!',
        iconColor: '#4B80E7',
    },
    {
        name: 'See Talent and Fill Positions',
        description: 'Review profiles of the highest matched talent, invite them to participate, request interview and select individuals to fill open positions.',
        iconColor: '#5AE399'
    },
    {
        name: 'SOW',
        description: 'Contracts for approval will be created and signed. Get started right away!',
        iconColor: '#E54963'
    },
]

const ByoStepsDescriptionsSVG = ({fill = '#000000', height = 60}) => (
    <svg version="1.1" height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 294.25">
        <path fill={fill}
              d="M0.01,147.12c-0.7-50.05,26.06-84.4,59.7-108.23C83.36,22.15,131.9,0,185.17,0s89.76,46.34,102.33,78.81,c11.14,28.77,21.73,102.37-0.7,147.63c-17.25,34.82-49.06,67.81-113.54,67.81s-115.89-35.07-137.37-58.4,C11.35,209.21,0.49,181.22,0.01,147.12z"/>
    </svg>
)

export default class ServiceStep extends ProjectStep {
    static TranslationKey = 'service_step';
    static path = '/select-service';
    static slug = 'select-service';
    static RequiresProject = false;

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;
        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {projectId})
    }

    /**
     * The subtitle shown on the form
     */
    static get StepSection() {
        return Project.ProjectSections.SectionType;
    }

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return false
    }

    static canEdit(project) {
        return project && project.id !== 'new'
    }

    static HideNavbar = true;

    static ValidationMethodName = 'validateService';

    constructor(props) {
        super(props);

        this.modalRef = React.createRef();
        this.serviceOverviewRef = React.createRef();
        console.log('constructor', props.queryParams)
        this.state = {
            ...this.state,
            servicesOpen: false,
            isLoading: false,
            servicesEnabled: true // laravel.platform_features.clients.services
            // TODO Change with updated platform features for teams
        };
    }

    static hasCompleted(project) {

        return project.validateService();
    }

    /**
     * @param {project} project
     * @returns {Object}
     */
    static reviewMapping(project) {
        return null
    }

    selectService(selectedService) {
        let service = TB.pick({...selectedService}, ["estimated_cost", "id", "name", "questions"]);

        return this.props.onSubmit({
            id: this.props.project.id,
            service,
            type: TB.invert(laravel.project_types)[Project.ProjectType.Service]
        });
    }

    chooseServiceCategory(category) {

        // if (selectedService.is_call_only && window.Intercom) {
        //     // open chat
        //     // console.log(`opening intercom chat w/ message "Hello.  I'm interested in hearing more about ${selectedService.name} service."`);
        //     return window.Intercom(
        //         'showNewMessage',
        //         `Hello.  I'm interested in hearing more about your ${selectedService.name} service.`
        //     );
        // }


    }

    render() {

        if (TB.isDefined(this.props.project?.id) && this.props.project.id !== 'new') {
            return <Navigate to={generatePath(TB.routes().clientProjectSetup, {projectId: 'new'})} replace={true}/>
        }

        const servicesOpen = TB.isDefined(this.props.queryParams?.['option-b'])
        const serviceCategories = TB.orderBy(laravel.project_template_categories, 'display_index', 'asc')

        return (
            <div className="wizard-step mt-3">
                <div className="px-4 w-full max-w-6xl">

                    <div className="services-step-header">
                        Create a New Project
                    </div>

                    <div className="white-panel py-6 px-4 sm:px-12 md:px-14">
                        <div className="flex flex-row justify-between">
                            <div>
                                <h5 className="panel-subtitle">
                                    {this.translate('byo_option')}
                                </h5>
                            </div>
                            <Link to={{...this.props.location, search: servicesOpen ? "" : "?option-b=1"}} replace
                                  className="btn-link btn-link-dark">
                                <span className="text-black">
                                    {servicesOpen ? 'EXPAND' : 'HIDE'}
                                </span>
                            </Link>
                        </div>
                        <div className={TB.mapClass("flex justify-between flex-wrap", {"flex-col": !servicesOpen})}>

                            <div className="search-info service-info p-0">
                                <h1>{this.translate('byo_title')}</h1>
                                <p>
                                    {/* Hire one or more digital experts for your project on an hourly basis. */}
                                    Extend your team with one or more experts across 45+ roles and 100s of skills.
                                    Create a team that meets your exact needs.
                                </p>
                            </div>


                            <Collapse isOpen={!servicesOpen}>
                                <div className="flex flex-row justify-between flex-wrap">
                                    <div className="w-full lg:w-7/12 lg:pr-3 xl:pr-5">

                                        <div className="byo-steps-descriptions-container mt-3 lg:mt-0">
                                            {byo_steps_descriptions.map((item, index) => (
                                                (<div className="flex my-6" key={item.name}>
                                                    <div className="relative self-center">

                                                        <ByoStepsDescriptionsSVG fill={item.iconColor}/>
                                                        <p className="byo-steps-descriptions-index">{index + 1}</p>
                                                    </div>
                                                    <div className="byo-steps-descriptions-text">
                                                        <h5>{item.name}</h5>
                                                        <p>{item.description}</p>
                                                    </div>
                                                </div>)
                                            ))}
                                        </div>
                                    </div>


                                    {/* Render on mobile only */}
                                    <div className="lg:hidden w-100 pt-0 md:py-2">
                                        <BYORoles
                                            roleOpened={this.state.roleOpened}
                                            onRoleOpen={roleOpened => this.setState({roleOpened})}
                                        />
                                    </div>
                                    {/* Render on desktop only */}
                                    <div className="hidden lg:block lg:w-5/12 pl-3">
                                        <BYORoles
                                            roleOpened={this.state.roleOpened}
                                            onRoleOpen={roleOpened => this.setState({roleOpened})}
                                        />
                                    </div>
                                </div>


                                <div className="form-search pt-4">
                                    <button type="button"
                                            className="btn btn-primary get-started"
                                            onClick={() => {
                                                let project = {
                                                    id: this.props.project.id,
                                                    type: TB.invert(laravel.project_types)[Project.ProjectType.BYO]
                                                };

                                                if (this.context?.auth?.last_client_project_group_id) {
                                                    project.client_project_group_id = this.context?.auth?.last_client_project_group_id;
                                                }

                                                this.props.onSubmit(project)
                                            }}>
                                        {this.translate('byo_start_btn')}
                                    </button>
                                </div>
                            </Collapse>

                        </div>
                    </div>


                    {this.state.servicesEnabled && (
                        <div className="white-panel py-6 px-4 sm:px-12 md:px-14 service-option-search">

                            <div className="flex flex-row justify-between">
                                <div>
                                    <h5 className="panel-subtitle">
                                        {this.translate('service_option')}
                                    </h5>
                                </div>
                                <Link to={{...this.props.location, search: servicesOpen ? "" : "?option-b=1"}} replace
                                      className="btn-link btn-link-dark">
                                    <span className="text-black">
                                        {servicesOpen ? 'HIDE' : 'EXPAND'}
                                    </span>
                                </Link>
                            </div>
                            <div className="flex justify-between flex-wrap">

                                <div className="search-info service-info p-0">
                                    <h1>{this.translate('service_title')}</h1>
                                    <p>
                                        Select from 50+ project types with configurable ready-made teams and
                                        deliverables. Pay a fixed-price for all work.
                                    </p>
                                </div>

                                {/*{!servicesOpen && (*/}
                                {/*    <div className="form-search">*/}
                                {/*        <button*/}
                                {/*            type="button"*/}
                                {/*            className="btn btn-primary get-started !self-start"*/}
                                {/*            onClick={() => this.setState({servicesOpen: !servicesOpen})}*/}
                                {/*        >*/}
                                {/*            {this.translate('byo_start_btn')}*/}
                                {/*        </button>*/}
                                {/*    </div>*/}
                                {/*)}*/}

                            </div>

                            <Collapse isOpen={servicesOpen}>


                                <div className="flex items-stretch relative overflow-hidden flex-col gap-8">
                                    <div>
                                        <p className="text-lg my-3 font-semibold">
                                            Shop By Category
                                        </p>
                                        <Scrollbars style={{width: `100%`, height: 250}}>
                                            <div
                                                className="flex flex-row flex-nowrap items-center justify-start py-4 gap-4">
                                                {serviceCategories.map((cat) => {
                                                    return (
                                                        <div
                                                            key={cat.id}
                                                            className="group bg-[#F7F8FA] hover:bg-[#D3D8DD] flex flex-col items-center justify-between px-3.5
                                                            py-4 gap-2 min-h-[215px] min-w-[188px] max-w-[188px]">
                                                            <div className="w-16 h-16 group-hover:hidden flex flex-col items-center justify-center"
                                                                style={Service.categoryIcon(cat.name)}>

                                                                <i className={Service.categoryIconClass(cat.name)}/>

                                                            </div>
                                                            <p className="font-semibold text-center group-hover:self-start group-hover:text-left">
                                                                {cat.name}
                                                            </p>
                                                            <p className="flex-grow hidden group-hover:flex flex-col items-start justify-start">
                                                                <span className="line-clamp-5 text-left text-xs text-black">{cat.description}</span>
                                                            </p>
                                                            <Link to={`teams/c${cat.id}/find-project-type`}
                                                                  className="btn btn-primary">
                                                                Get Started
                                                            </Link>
                                                        </div>
                                                    )
                                                })}
                                            </div>

                                        </Scrollbars>
                                    </div>
                                    <div>
                                        <p className="text-lg my-3 font-semibold">
                                            Not sure which category to choose?
                                        </p>

                                        <div
                                            className="mt-6 border-2 border-[#4A80E7] flex flex-row items-stretch h-[235px] flex-wrap relative">
                                            <div
                                                className="flex-1 h-full min-h-full relative flex flex-col items-start justify-center gap-3.5 bg-[#4A80E7] px-4">
                                                <h2 className="text-white">
                                                    Search our project catalog
                                                    using <span className="font-bold">Smart Search</span>.
                                                </h2>
                                                <Link className="btn btn-white bg-white" to="teams/find-project-type">
                                                    <span className="text-black">
                                                        Try Smart Search
                                                    </span>
                                                </Link>
                                            </div>
                                            <div className="flex-1 h-full min-h-full relative">
                                                <img src="/images/dashboard/smart_search.png" alt="Smart Search imagry" className="relative h-full min-h-full object-cover"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Collapse>
                        </div>
                    )}
                </div>

            </div>
        );
    }
}